import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import * as t from "io-ts";

const CodeBoxSendResponseV = t.union([
  t.type({
    status: t.literal("success"),
    data: t.type({
      snippetId: t.number
    })
  }),
  t.type({
    status: t.literal("codebox_not_installed")
  })
]);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
type CodeBoxSendResponse = t.TypeOf<typeof CodeBoxSendResponseV>;

export async function sendToCodeBox(code: string) {
  return await makeWordPressAjaxRequest({
    action: "breakdance_codebox_send",
    decoder: CodeBoxSendResponseV,
    friendlyName: `Send code to CodeBox`,
    dataToPost: { code }
  });
}
